import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import {AiFillHome, AiFillPhone} from "react-icons/ai";

const Appointment = () => {

    const mapLink = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.1234567890!2d77.296799!3d30.135527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f1234567890ab%3A0x1234567890abcdef!2sShop%20No.%206%2C%20Sharma%20Garden%2C%20Near%20Mahindra%20Petrol%20Pump%2C%20Yamunanagar%2C%20Haryana%20135001!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin'

    return (
        <section className='appointment-section pb-70'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <div id="map" className="google-map">
                            <iframe title='map' src={mapLink}></iframe>

                            <div className="location-name">
                                <AiFillHome />
                                <p>Shop No. 6, Sharma Garden, Near Mahindra Petrol Pump, Yamunanagar – 135001 (HR)</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <SectionTitle 
                            subTitle="CALL US NOW"
                            title="Ready to book your appointment?"
                            description="Call or WhatsApp us directly for immediate assistance. Our team is ready to help you with your dental care needs."/>

                            <div className="contact-info-cards">
                                <div className="contact-card">
                                    <div className="contact-icon">
                                        <AiFillPhone />
                                    </div>
                                    <div className="contact-details">
                                        <h4>Call/WhatsApp</h4>
                                        <a href="tel:6395947006" className="phone-number">6395947006</a>
                                        <p>Available during clinic hours</p>
                                    </div>
                                </div>
                                
                                <div className="contact-card">
                                    <div className="contact-icon">
                                        <AiFillHome />
                                    </div>
                                    <div className="contact-details">
                                        <h4>Walk-in Timings</h4>
                                        <p className="timing">Morning: 10:00 AM - 1:30 PM</p>
                                        <p className="timing">Evening: 5:30 PM - 7:30 PM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;